import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { DataService } from '../../../@core/services/data.service';
import { FeatureProgressBarModel, ProgressBarInterface } from '../../../@core/models/site-data.model';
import { MatDialog } from '@angular/material/dialog';
import * as Sentry from "@sentry/browser";
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialProgressBarComponent implements OnInit {

  @Input() features: FeatureProgressBarModel[];
  @Input() grayedOut: boolean = true;
  backgroundColor: string;
  data: ProgressBarInterface;
  activatePadding: boolean = false;
  active: boolean = false;
  position: number = 0;
  moduleInfo: string;
  loading: boolean = true;
  allElementAnimation: string;
  itemsAnimation: string;

  constructor(private dataService: DataService,
    private _snackBar: MatSnackBar, private dialog: MatDialog) { }

  ngOnInit() {
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.itemsAnimation = this.data.animation.items != '' ? this.data.animation.items : undefined;

    }
    this.loading = false
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "ProgressBarComponent");
    });
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.features = this.data.features;
    this.backgroundColor = this.data ? this.data.backgroundColor : '';
  }

}
